module.exports = __webpack_public_path__ + "img/stock-bg.5e0d4557.jpg";